import orderBy from 'lodash/orderBy';
import { BAGGAGES } from './constants';

const isProductSetUnavailable = (productsArray, includedProductsArray, extraProductIdsSet) => {
  const setProductsThatArePartOfIncluded = includedProductsArray?.filter((product) =>
    extraProductIdsSet.has(product.id),
  );

  const setProductsThatArePartOfAvailable = productsArray?.filter((product) =>
    extraProductIdsSet.has(product.id),
  );

  return [...setProductsThatArePartOfAvailable, ...setProductsThatArePartOfIncluded].length === 0;
};

const retrieveProductByIdFromArray = (array = [], productId) =>
  array.filter((product) => product.id === productId);

export const hasExcludedSystemProvider = (
  tripProviderSystems,
  productsPerTravelerExcludedProviderSystems,
) => {
  const productsPerTravelerExcludedProviderSystemsArray =
    productsPerTravelerExcludedProviderSystems?.split(',') ?? [];

  const isProviderExcluded = (provider) =>
    productsPerTravelerExcludedProviderSystemsArray.includes(provider);

  return tripProviderSystems?.some(isProviderExcluded);
};

const isInWantedProducts = (products) => (product) =>
  products.includes(product?.code) || product?.code === '';
const isNotInWantedProducts = (products) => (product) =>
  !products.includes(product?.code) && product?.code !== '';

const removeSetFromArray = (set, array) => array.filter(({ code }) => !set.has(code));

const removeConflictingBaggages = (
  productsToDisplayPerTravelerArray,
  primaryProducts = [],
  secondaryProducts = [],
) => {
  const removeSet = new Set();

  if (!productsToDisplayPerTravelerArray.includes(BAGGAGES.CABIN_BAGGAGE)) {
    removeSet.add(BAGGAGES.CABIN_BAGGAGE);
  }

  const [filteredPrimaryProducts, filteredSecondaryProducts] = [
    primaryProducts,
    secondaryProducts,
  ].map((categoryArray) =>
    removeSetFromArray(
      removeSet,
      categoryArray.filter(isNotInWantedProducts(productsToDisplayPerTravelerArray)),
    ),
  );

  return [filteredPrimaryProducts, filteredSecondaryProducts];
};

const removeCabinBaggageFromProducts = (products) =>
  products.filter((product) => product.code !== BAGGAGES.CABIN_BAGGAGE);

export const getTravelerFormProducts = (
  productsToDisplayPerTraveler,
  shouldShowProductsPerTraveler,
  products,
  includedProducts,
  notAvailableProducts,
  checkInBaggageId,
  cabinBaggageId,
) => {
  const primaryProducts = products[0];
  const secondaryProducts = products[1] ?? [];

  if (!shouldShowProductsPerTraveler) {
    return {
      travelerFormProducts: [[]],
      filteredProductsArray: [
        removeCabinBaggageFromProducts(primaryProducts),
        removeCabinBaggageFromProducts(secondaryProducts),
      ],
      filteredIncludedProductsArray: includedProducts,
      isCheckedBaggageAvailableOrIncluded: false,
      isCabinBaggageAvailableOrIncluded: false,
    };
  }

  const productsToDisplayPerTravelerArray = productsToDisplayPerTraveler.length
    ? productsToDisplayPerTraveler.split(',')
    : [];

  const isCheckedBaggageShownInTravelerForm = productsToDisplayPerTravelerArray.includes(
    BAGGAGES.BAGGAGE,
  );

  const isCabinBaggageShownInTravelerForm = productsToDisplayPerTravelerArray.includes(
    BAGGAGES.CABIN_BAGGAGE,
  );

  const filteredProductsArray = removeConflictingBaggages(
    productsToDisplayPerTravelerArray,
    primaryProducts,
    secondaryProducts,
  );
  const filteredIncludedProductsArray = removeConflictingBaggages(
    productsToDisplayPerTravelerArray,
    includedProducts,
  );

  const isCheckedBaggageAvailableOrIncluded = !isProductSetUnavailable(
    [...primaryProducts, ...secondaryProducts],
    includedProducts,
    new Set([checkInBaggageId]),
  );

  const isCabinBaggageAvailableOrIncluded = !isProductSetUnavailable(
    [...primaryProducts, ...secondaryProducts],
    includedProducts,
    new Set([cabinBaggageId]),
  );

  const notAvailableCheckInBaggageProduct = isCheckedBaggageShownInTravelerForm
    ? retrieveProductByIdFromArray(notAvailableProducts, checkInBaggageId)
    : [];

  const notAvailableCabinBaggageProduct = isCabinBaggageShownInTravelerForm
    ? retrieveProductByIdFromArray(notAvailableProducts, cabinBaggageId)
    : [];

  const travelerFormProducts = [
    ...includedProducts,
    ...primaryProducts,
    ...notAvailableCheckInBaggageProduct,
    ...notAvailableCabinBaggageProduct,
  ].filter(isInWantedProducts(productsToDisplayPerTravelerArray));

  return {
    travelerFormProducts: orderBy(travelerFormProducts, ['id'], ['desc']),
    filteredProductsArray,
    filteredIncludedProductsArray,
    isCheckedBaggageAvailableOrIncluded,
    isCabinBaggageAvailableOrIncluded,
  };
};
